import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/hire_react/hire_react_banner.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service on_demand_banner cloud_cost_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              {/* <h1 className="web_head_banner">Build Scalable Cloud Apps</h1> */}
              <h1 style={{ marginBottom: "10px" }}>
                Hire ReactJS {}
                <span style={{ color: "#F47a14" }}>Developers</span>
              </h1>
              <p>
                TekRevol provides unparalleled assistance in sourcing and hiring
                elite React developers for freelance and full-time positions. By
                connecting you with the top 3% of React programmers, we offer
                access to one of the largest networks of rigorously vetted
                talent. We ensure that you hire React developers and experts who
                are reliable and highly skilled, giving you confidence and peace
                of mind in your hiring decisions.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Hire Your ReactJS Developers
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
